import LoaderElement from '@loaders/LoaderElement';

interface Props {
    className?: string;
    loaderElementsHeight?: number;
}

const LoaderTable = ({ className, loaderElementsHeight = 180 }: Props): JSX.Element => {
    return (
        <div className={`${className} loader-table`}>
            <LoaderElement height={loaderElementsHeight} />
            <LoaderElement height={loaderElementsHeight} />
            <LoaderElement height={loaderElementsHeight} />
            <LoaderElement height={loaderElementsHeight} />
        </div>
    );
};
export default LoaderTable;
